import Checkbox from "@components/inputs/CheckBox";
import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface SettingsTableRowProps {
  title: string;
  email: boolean;
  google2Fa: boolean;
  rounded?: boolean;
  onEmailChange: () => void;
  onGoogle2FaChange: () => void;
  isEmailEnabled?: boolean;
  isGoogle2FaEnabled?: boolean;
  loading?: boolean;
}

const SettingsTableRow: React.FC<SettingsTableRowProps> = ({
  title,
  email,
  google2Fa,
  rounded = false,
  isEmailEnabled,
  isGoogle2FaEnabled,
  onEmailChange,
  onGoogle2FaChange,
  loading,
}) => {
  return (
    <tr className={`${rounded ? "rounded-b-lg" : ""}`}>
      <td
        className={`${
          !rounded && "border-b border-border-table"
        } py-[15px] px-[8px] font-medium ${rounded ? "rounded-bl-lg" : ""}`}
      >
        {!loading ? (
          <div className="flex items-center h-full text-[14px] text-text-base font-normal">
            {title}
          </div>
        ) : (
          <Skeleton width={100} height={20} />
        )}
      </td>
      <td className={`${!rounded && "border-b border-border-table"} py-2 px-4`}>
        <div className="flex justify-center items-center h-full">
          <Checkbox
            onChange={onEmailChange}
            checked={email}
            isEnabled={isEmailEnabled}
            loading={loading}
          />
        </div>
      </td>
      <td
        className={`${!rounded && "border-b border-border-table"} py-2 px-4 ${
          rounded ? "rounded-br-lg" : ""
        }`}
      >
        <div className="flex justify-center items-center h-full">
          <Checkbox
            onChange={onGoogle2FaChange}
            checked={google2Fa}
            isEnabled={isGoogle2FaEnabled}
            loading={loading}
          />
        </div>
      </td>
    </tr>
  );
};

export default SettingsTableRow;
